import api from '../../config/axios.js';

const state = {
    users: '',
    usersByCategory: '',
    fetchPerformanceData: {},
    performanceRankingPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    },
    performanceQuery: {
        month: null,
        year: null,
        user_id: null,
    }
}
const getters = {
    getUsers: state => state.users,
    getUsersByCategory: state => state.usersByCategory,
    getPerformanceData: state => state.fetchPerformanceData,
    getPerformanceRankingPagination: state => state.performanceRankingPagination,
    getPerformanceQuery: state => state.performanceQuery,
}
const actions = {
    async fetchUsers({ commit }, params){
        await api.axios.get('/api/users', {params}).catch(() => {
            commit("fetchUsers", []);
        }).then(response => {
            if(response && response.data){
                commit("fetchUsers", response.data);
            } else {
                commit("fetchUsers", []);
            }
        });
    },
    async fetchUsersByCategory({ commit }, params){
        await api.axios.get('/api/users', {params}).catch(() => {
            commit("fetchUsersByCategory", []);
        }).then(response => {
            if(response && response.data){
                commit("fetchUsersByCategory", response.data);
            } else {
                commit("fetchUsersByCategory", []);
            }
        });
    },
    // BUSCANDO DADOS DE PERFORMANCE DE ATENDENTES
    async fetchPerformanceData({ commit }, params){
        const month = params && params.month ? params.month : null;
        const year = params && params.year ? params.year : null;
        const user_id = params && params.user_id ? params.user_id : null;
        const page = params && params.page ? params.page : 1;

        commit("setPerformanceQuery", { month, year, user_id });

        await api.axios.get(`/api/performance/attendant/${month}/${year}/${user_id}?page=${page}`).catch(() => {
            commit("fetchPerformanceData", {});
            commit("setPerformanceRankingPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
            });
        }).then(response => {
            if(response && response.data){
                const payload = response.data;
                const rankingPayload = payload && payload.ranking ? payload.ranking : [];
                const rankingList = Array.isArray(rankingPayload.data) ? rankingPayload.data : rankingPayload;
                const rankingPagination = Array.isArray(rankingPayload.data)
                    ? {
                        current_page: rankingPayload.current_page || page,
                        last_page: rankingPayload.last_page || 1,
                        per_page: rankingPayload.per_page || rankingList.length,
                        total: rankingPayload.total || rankingList.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: rankingList.length || 10,
                        total: rankingList.length || 0,
                    };

                commit("fetchPerformanceData", {
                    ...payload,
                    ranking: rankingList
                });
                commit("setPerformanceRankingPagination", rankingPagination);
            } else {
                commit("fetchPerformanceData", {});
                commit("setPerformanceRankingPagination", {
                    current_page: 1,
                    last_page: 1,
                    per_page: 10,
                    total: 0,
                });
            }
        });

    },
}

const mutations = {
    fetchUsers: function(state, data){
        state.users = data;
    },
    fetchUsersByCategory: function(state, data){
        state.usersByCategory = data;
    },
    fetchPerformanceData: function(state, data){
        state.fetchPerformanceData = data;
    },
    setPerformanceRankingPagination: function(state, data){
        state.performanceRankingPagination = data;
    },
    setPerformanceQuery: function(state, data){
        state.performanceQuery = {
            month: data ? data.month : null,
            year: data ? data.year : null,
            user_id: data ? data.user_id : null,
        };
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}